<div class="test-screen-container">
    
    <div class="test-overlay" *ngIf="isSubmitting">
        <app-test-generation-loader
            [steps]="evaluationSteps"
            centerIcon="bar_chart"
            [stepIntervalMs]="1800">
        </app-test-generation-loader>
    </div>

    
    <div class="test-overlay quitting" *ngIf="isQuitting">
        <div class="overlay-content">
            <mat-icon>exit_to_app</mat-icon>
            <p>Quitting test...</p>
            <span>Navigating back to placement prep</span>
        </div>
    </div>

    
    <div class="test-header">
        <div class="test-info">
            <h1 class="test-title">{{ testTitle }}</h1>
            <span class="test-subtitle">Exam Mode</span>
        </div>
        <div class="header-actions">
            <div class="timer-badge">
                <i class="fa-regular fa-clock"></i>
                <span>{{ timerDisplay }}</span>
            </div>
            <button class="btn-submit-header" (click)="submitTest()">Submit Test</button>
        </div>
    </div>

    <div class="main-content">
        
        <div class="question-area card">
            <div class="question-scroll-content">
                <div class="question-header">
                    <span class="question-number">Question {{ currentQuestionIndex + 1 }} of {{ questions.length
                        }}</span>
                    <span class="difficulty-badge" *ngIf="currentQuestion as question">{{ question.difficulty_level
                        }}</span>
                </div>

                <div class="question-text" *ngIf="currentQuestion as question">
                    {{ question.question_text }}
                </div>

                <div class="options-list" *ngIf="currentQuestion as question">
                    <div class="option-item" *ngFor="let option of question.options; let i = index"
                        [class.selected]="isOptionSelected(option.text)" (click)="selectOption(option)">
                        <div class="option-label">{{ getOptionLabel(i) }}</div>
                        <div class="option-text">{{ option.text }}</div>
                    </div>
                </div>
            </div>

            
            <div class="question-footer">
                <div class="left-controls">
                   <button
    class="btn-review"
    [class.active-review]="reviewList.has(currentQuestion?.question_id!)"
    (click)="toggleReview()">

    <i class="fa-regular fa-flag"></i>

    <span *ngIf="!reviewList.has(currentQuestion?.question_id!)">
        Mark for Review
    </span>

    <span *ngIf="reviewList.has(currentQuestion?.question_id!)">
        Remove Review
    </span>

</button>
                    
                    <button class="btn-text" (click)="clearResponse()"
                        *ngIf="answers.get(currentQuestion?.question_id!)">Clear</button>
                </div>

                <div class="right-controls">
                    <button class="btn-nav previous" (click)="prevQuestion()" [disabled]="currentQuestionIndex === 0">
                        <i class="fa-solid fa-chevron-left"></i> Previous
                    </button>
                    <button class="btn-nav next" (click)="isAllAnswered ? submitTest() : nextQuestion()">
                        <ng-container *ngIf="!isAllAnswered">
                            Save & Next <i class="fa-solid fa-chevron-right"></i>
                        </ng-container>
                        <ng-container *ngIf="isAllAnswered">
                            Submit
                        </ng-container>
                    </button>
                </div>
            </div>
        </div>

        
        <div class="sidebar">
            <div class="palette-card card">
                <h3 class="palette-title">Question Palette</h3>

                <div class="legends">
                    <div class="legend-item">
                        <span class="dot answered"></span>
                        <span>Answered ({{ answers.size }})</span>
                    </div>
                    <div class="legend-item">
                        <span class="dot review"></span>
                        <span>Review ({{ reviewList.size }})</span>
                    </div>
                    <div class="legend-item">
                        <span class="dot current"></span>
                        <span>Current</span>
                    </div>
                    <div class="legend-item">
                        <span class="dot not-answered"></span>
                        <span>Not Answered</span>
                    </div>
                </div>

                <div class="palette-grid">
                    <button *ngFor="let q of questions; let i = index" class="palette-btn"
                        [ngClass]="getQuestionStatus(q, i)" (click)="goToQuestion(i)">
                        {{ i + 1 }}
                    </button>
                </div>
            </div>
            
        </div>
    </div>
</div>